var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"cc-pill",class:'cc-pill--' + _setup.meta.tone},[_c('span',{staticClass:"ms cc-pill-icon"},[_vm._v(_vm._s(_setup.meta.icon))]),_vm._v(" "+_vm._s(_setup.meta.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }